import { ResponsiveAntdTable, ResponsiveAntdTableProps } from "@/Components/ResponsiveAntdTable";
import Titulo, { EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";
import { useListar } from "@/Services/Financeiro/Titulo/TituloService";
import Ordenar from "@/Utils/Ordenacao";
import Utilitario from "@/Utils/Utilitario";
import { Space } from "antd";
import OpceosTitulo from "./OpceosTitulo";
import { SettingOutlined } from "@ant-design/icons";

export interface ITituloTableProps extends ResponsiveAntdTableProps<Titulo> {
    codFatura : number;
    // isDesativar?: boolean,
    // isAtivar?: boolean,
    // isPagar?: boolean,
    // isVisualizar?: boolean;
    // onEditar?: (titulo: Titulo) => void,
    // onVisualizar?: (titulo: Titulo) => void,
    // filtros:[ITituloTableFiltros|undefined, React.Dispatch<React.SetStateAction<ITituloTableFiltros|undefined>>],
    // enabledQueryState:[boolean, React.Dispatch<React.SetStateAction<boolean>>]
}
export default function TituloTableParcela({
    codFatura,
    ...rest
}:ITituloTableProps) {
    const {
        data,
        isLoading,
        isFetching,
        refetch
    } = useListar({
        titulo : {
            codFatura : codFatura
        },
        ativo : true,
        enabled : codFatura > 0
    });

    return <ResponsiveAntdTable<Titulo>
        {...rest}
        bordered
        locale={{ emptyText: 'Nenhuma parcela foi encontrada.' }}
        dataSource={data}
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x: true,
        }}
        showHeader={true}
        minColWidthIfResponsivenessDisabled={"120px"}
        loading={isLoading || isFetching}
        rowKey={(k) => k.codigo}
        columns={[
            {
                title: "ID",
                dataIndex: "codigo",
                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                key: "codigo",
                minWidth : "70px"
            },
            // {
            //     title: "Tipo",
            //     dataIndex: "codTipo",
            //     render: (codTipo, _) => codTipo === EnumTituloTipo.Titulo ? "Título" : "Parcela",
            //     key: "codTipo",
            //     minWidth : "70px"
            // },
            // {
            //     title: "Título",
            //     dataIndex: "codFatura",
            //     render: (codFatura, _) => codFatura ?? ' - ',
            //     key: "codTipo",
            //     minWidth : "70px"
            // },
            // data?.[0]?.beneficiario?.tipo === EnumPessoaTipo.EMPRESA ? undefined : {
            //     title: "Beneficiário",
            //     dataIndex: ["beneficiario", "nome"],
            //     render: (_, titulo) => titulo.beneficiario?.nomeSocial == null ? titulo.beneficiario?.nome : titulo.beneficiario?.nomeSocial,
            //     sorter: (titulo1, titulo2) => Ordenar.String(titulo1.beneficiario?.nomeSocial == null ? titulo1.beneficiario?.nome : titulo1.beneficiario?.nomeSocial, titulo2.beneficiario?.nomeSocial == null ? titulo2.beneficiario?.nome : titulo2.beneficiario?.nomeSocial),
            //     key: "beneficiario",
            //     minWidth : "200px"
            // },
            // data?.[0]?.beneficiario?.tipo !== EnumPessoaTipo.EMPRESA ? undefined : {
            //     title: "Devedor",
            //     dataIndex: ["devedor", "nome"],
            //     render: (_, titulo) => titulo.devedor?.nomeSocial == null ? titulo.devedor?.nome : titulo.devedor?.nomeSocial,
            //     sorter: (titulo1, titulo2) => Ordenar.String(titulo1.devedor?.nomeSocial == null ? titulo1.devedor?.nome : titulo1.devedor?.nomeSocial, titulo2.devedor?.nomeSocial == null ? titulo2.devedor?.nome : titulo2.devedor?.nomeSocial),
            //     key: "devedor",
            //     minWidth : "200px"
            // },
            {
                title: "Vencimento",
                dataIndex: "dataVencimento",
                render: (value: Date, titulo:Titulo) => titulo.codTipo === EnumTituloTipo.Parcela ? value.toLocaleDateString() : '',
                sorter: (titulo1, titulo2) => Ordenar.Data(titulo1.dataVencimento, titulo2.dataVencimento),
                key: "dataVencimento",
                breakpoints : { xs : 12, sm : 6, md : 5, lg : 5, xl : 3, xxl : 3 }
            },
            {
                title: "Valor Prev.",
                dataIndex: "valorPrevisto",
                render: (value: number, titulo:Titulo) => titulo.codTipo === EnumTituloTipo.Parcela ? Utilitario.toStringDinheiro(value) : '',
                sorter: (titulo1, titulo2) => Ordenar.Numero(titulo1.valorPrevisto, titulo2.valorPrevisto),
                key: "valorPrevisto",
                breakpoints : { xs : 12, sm : 6, md : 4, lg : 4, xl : 3, xxl : 3 }
            },
            {
                title: "Situação",
                dataIndex: ["situacao", "nome"],
                render : (value:string|undefined) => value ?? ' - ', 
                sorter: (a, b) => Ordenar.Numero(a.situacao?.ordem, b.codigo),
                key: "situacao",
                minWidth : "100px"
            },
            {
                key: "acoes",
                title: "Ações",
                fixed: "right",
                minWidth : "10px",
                render: (_, titulo) => <Space size="small" wrap style={{ justifyContent : "center" }}>
                    <OpceosTitulo
                        isDesativar={true}
                        isAtivar={true}
                        isPagar={true}
                        isVisualizar={true}
                        // onEditar={(titulo: Titulo) => onEditar?.(titulo)}
                        onSucess={() => refetch()}
                        titulo={titulo}
                        children={<SettingOutlined />}
                    />
                </Space>
            }
        ].filter(f => f !== undefined)}
    />
}